import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('KYC/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('KYC/GetDetail', { params: { id } });
  },
  approve(_, id) {
    return axios.get('KYC/Approve', { params: { id } });
  },
  save(_, form) {
    return axios.post('KYC/save', form);
  },
  saveWithFile(_, formData) {

    return axios.post('KYC/SaveWithFile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  delete(_, id) {
    return axios.get('KYC/Delete', { params: { id } });
  },
};
